import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link, LinkProps } from 'react-router-dom';

import { useBaseUrlFromLocale } from 'utils/AppRoute';
import { ensureNoTrailingSlash } from 'utils/Urls';

import type { IContentLink } from './IContentLink';

export interface ILocaleLinkProps
  extends IContentLink<HTMLAnchorElement>,
    Pick<LinkProps, Exclude<keyof LinkProps, 'innerRef' | 'target'>> {}

export const LocaleLink: React.FC<ILocaleLinkProps> = ({ children, to: pathname, ...props }, innerRef) => {
  const { i18n } = useTranslation();
  const baseUrl = useBaseUrlFromLocale(i18n.language);
  const toUrl = baseUrl ? `${ensureNoTrailingSlash(baseUrl)}${pathname}` : pathname;

  return (
    <Link innerRef={innerRef} to={toUrl} {...props}>
      {children}
    </Link>
  );
};
